import { FinancialSummaryMath } from '../FinancialSummaryMath/FinancialSummaryMath';

export class V3SettlementMath extends FinancialSummaryMath {
  constructor(offer, budget) {
    super(offer, budget, true);

    this.settlementLineItems = offer.v3_settlement_line_items || [];
    this.settlementOverrides = offer.v3_settlement_overrides || [];
    this.settlementVisibilities = offer.v3_settlement_visibilities || [];
  }

  getVisibility(itemId, itemType) {
    const visibility = this.settlementVisibilities.find(
      (v) => v.overridable_id === itemId && v.overridable_type === itemType
    );
    return visibility ? visibility.visible : true;
  }

  getOverride(itemId, itemType) {
    return this.settlementOverrides.find(
      (o) => o.overridable_id === itemId && o.overridable_type === itemType
    );
  }

  applyOverrides(calculatedItems) {
    return calculatedItems.map((item) => {
      const override = this.getOverride(item.id, 'V3BudgetLineItem');
      const visible = this.getVisibility(item.id, 'V3BudgetLineItem');

      if (!visible) {
        return { ...item, settlementHidden: true };
      }

      if (override) {
        return {
          ...item,
          name: override.name || item.name,
          calculatedTotal: override.amount != null ? parseFloat(override.amount) : item.calculatedTotal,
          settlementOverridden: true,
        };
      }

      return item;
    });
  }

  recalculateSectionTotals(section) {
    if (!section || !section.items) return;

    let total = 0;
    let externalTotal = 0;
    let internalTotal = 0;

    for (const item of section.items) {
      if (item.settlementHidden) continue;
      const itemTotal = item.calculatedTotal || 0;
      total += itemTotal;
      if (item.show_in_offer !== false) {
        externalTotal += itemTotal;
      } else {
        internalTotal += itemTotal;
      }
    }

    section.total = total;
    section.externalTotal = externalTotal;
    section.internalTotal = internalTotal;
  }

  calculateSettlement() {
    const resultJson = this.calculate();
    const result = JSON.parse(resultJson);

    if (result.ticketsSection && result.ticketsSection.items) {
      result.ticketsSection.items = this.applyOverrides(result.ticketsSection.items);
    }
    if (result.expensesSection && result.expensesSection.items) {
      result.expensesSection.items = this.applyOverrides(result.expensesSection.items);
    }
    if (result.revenueSection && result.revenueSection.items) {
      result.revenueSection.items = this.applyOverrides(result.revenueSection.items);
    }

    for (const sli of this.settlementLineItems) {
      const section = this.getSectionForSettlementItem(sli.section, result);
      if (section && section.items) {
        section.items.push({
          name: sli.name || 'Settlement Item',
          calculatedTotal: parseFloat(sli.amount) || 0,
          quantity: sli.quantity,
          isSettlementLineItem: true,
        });
      }
    }

    this.recalculateSectionTotals(result.ticketsSection);
    this.recalculateSectionTotals(result.expensesSection);
    this.recalculateSectionTotals(result.revenueSection);
    this.recalculateSectionTotals(result.beforeAdjustedDeductionsSection);
    this.recalculateSectionTotals(result.additionsSection);

    return result;
  }

  getSectionForSettlementItem(sectionName, result) {
    switch (sectionName) {
      case 'tickets': return result.ticketsSection;
      case 'income': return result.revenueSection;
      case 'expenses': return result.expensesSection;
      case 'deductions': return result.beforeAdjustedDeductionsSection;
      case 'additions': return result.additionsSection;
      default: return null;
    }
  }
}
